import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
import logo from "../../assets/loginlogo.jpg";

function HomeNavbar({ user, handleLogout, handleProfile }) {
  const [show, setShow] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [isExercisesOpen, setIsExercisesOpen] = useState(false);

  const transitionNavbar = () => {
    if (window.scrollY > 100) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
  };

  useEffect(() => {
    window.addEventListener("scroll", transitionNavbar);
    return () => window.removeEventListener("scroll", transitionNavbar);
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showMobileMenu = windowWidth <= 768;

  return (
    <nav className="main-navbar" style={{ position: "fixed", width: "100vw", left: 0 }}>
      <div className="navbar-brand">
        <Link to="/">
          <img src={logo} alt="Institute Logo" height="30px" width="30px" style={{ borderRadius: "100%" }} />
          <span>PITMANSTENO</span>
        </Link>
      </div>

      {isNavVisible ? (
        <ul className={`nav-items`}>
          <li className="nav-item">{showMobileMenu ? <GiHamburgerMenu onClick={() => toggleNav()} /> : ""}</li>
        </ul>
      ) : (
        <ul className={`nav-items`}>
          <li className="nav-item">{!showMobileMenu ? "" : <FaTimes onClick={() => toggleNav()} />}</li>
          <li className="nav-item">
            <Link to="/">Home</Link>
          </li>
          <li className="nav-item dropdown" onMouseEnter={() => setIsExercisesOpen(true)} onMouseLeave={() => setIsExercisesOpen(false)}>
            <button type="button" className="nav-link-button" onClick={() => setIsExercisesOpen((prev) => !prev)}>
              Exercises
            </button>
            <ul className={`dropdown-menu ${isExercisesOpen ? "show" : ""}`}>
              <li>
                <Link to="/demo-write-image" onClick={() => setIsExercisesOpen(false)}>
                  Give Passage Based Test
                </Link>
              </li>
              <li>
                <Link to="/demo-write-audio" onClick={() => setIsExercisesOpen(false)}>
                  Give Audio Based Test
                </Link>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <Link to="/about">About</Link>
          </li>
          <li className="nav-item">
            <Link to="/courses">Courses</Link>
            {/* <Link to="/subscription">Courses</Link> */}
          </li>
          <li className="nav-item">
            <Link to="/contact">Contact</Link>
          </li>
          <li className="nav-item">
            <Link to="/cancellation-and-refund-policy">Cancellation & Refund Policy</Link>
          </li>
          {user && user.role === "student" && (
            <li className="nav-item">
              <Link to="/dashboard/student">Dashboard</Link>
            </li>
          )}
        </ul>
      )}

      {!user && (
        <div className="navbar-user">
          <Link to="/login" className="login-link">
            <button className="logout-button">Login</button>
          </Link>
        </div>
      )}

      {user && (
        <div className="navbar-user">
          <span className="user-greeting" onClick={handleProfile}>
            Hello, {user.username}
          </span>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      )}
    </nav>
  );
}

export default HomeNavbar;
